<template>
    <div class="flex flex-row" v-bind:class="{ 'flex-col': isMobileScreen }">
      <div class="box-card barging-table" v-bind:class="{ 'mobile-view': isMobileScreen }">
        <div class="barging-pagination">
        </div>
      </div>
      <div class="timeline-container">
        
      </div>
    </div>
</template>

<script>
import { getShipVettingHistory } from "@/services";
import { mapState } from "vuex";
import ShipVettingTimeline from './timeline.vue'
import { getShipVettingStatus } from "@/utils/constants";
export default {
  name: "ShipVettingHistory",
  components: { ShipVettingTimeline },
  props: {
    imo: {
      default: null,
    },
    shipName: {
      default: null,
    },
  },
  watch: {
    imo() {
      this.getList();
    },
    // immediate: true,
  },
  data() {
    return {
      historyListData: [],
      rid: "",
      listData: [],
      pageParams: {
        pageNum: 1,
        pageSize: 20,
      },
      total: 0,
    };
  },
  computed: {
    ...mapState(["userInfo", "screenType"]),
    isMobileScreen() {
      return this.screenType?.isMobileScreen ?? false;
    }
  },
  created() {
    this.getList();
  },
  mounted() {
    // const { id, status } = this.$route.query;
    // console.log("ID:", id, "Status:", status);
  },
  methods: {
    getShipVettingStatus,
    getList() {
      let data = {
        ...this.pageParams,
        imo: this.imo
      };

      getShipVettingHistory(data).then((res) => {
        if (res.code == 200) {
          this.historyListData = res.rows;
          this.total = res.total
        }
      });

      // if(this.historyListData?.length > 0){
      //   this.rid = row.id
      // }
    },
    getCellStyle({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return {
          backgroundColor: "rgba(255,255,255,0.2)",
        };
      } else {
        return {
          backgroundColor: "rgba(228,228,228,0.2)",
        };
      }
    },
    handleTableRowClick(row) {
      this.rid = row.id ?? '7492766509353728'
    },
    formatCompleteTime(row, column, cellValue) {
      if (!cellValue) return '';
      return cellValue.replace('T', ' ');
    }
  },
};
</script>

<style scoped lang="scss">
::v-deep .el-table .cell {
  word-break: normal;
}

.timeline-container {
  border-left: 2px solid #d7d9e1;
  max-width: 400px;
  height: 100%;
}

</style>
